
import { ILbl    } from "../../../../../src/lbl/ILbl"

enum OpLblStatusEnum  { 
    PLIK_UPLOAD_OK    = "PLIK_UPLOAD_OK", 
    PREFLIGHT_OK      = "PREFLIGHT_OK"  , 
    PREFLIGHT_ERR     = "PREFLIGHT_ERR" , 
    SEKWENCJA_OK      = "SEKWENCJA_OK"  , 
    SEKWENCJA_ERR     = "SEKWENCJA_ERR" , 
    AKCEPTACJA_OK     = "AKCEPTACJA_OK" , 
    AKCEPTACJA_ERR    = "AKCEPTACJA_ERR", 
} 

export enum OpTouchEnum {
    CREATE      = 'C',
    UPDATE      = 'U',
    DELETE      = 'D',
    NO_ACTION   = ''
}

export enum OpStatusEnum  { 
    START    = "START", 
    OK       = "OK", 
    WARN     = "WARN", 
    ERROR    = "ERR", 
} 

export interface IOpHistoryEvent {
    date: Date;             // data wpisu
    who: string;            // kto wpisał
    status: OpStatusEnum;   // 
    msg: string
}

export interface IOpHistory {
    _id:any
    events: IOpHistoryEvent[]
}


export interface IOpStatus {
    msg:string
    status: OpStatusEnum
    obj: any

    err(msg:string):void
    ok(msg:string):void
    warn(msg:string):void
}

export interface IOpResult {
    is_array: number
    is_obj: number

    array:any[]
    obj:any[]
    msg:string[]

    status:OpStatusEnum
}

export interface IOpNode {
    _id: any;
    parent_id: any;
    version: number;
    type: string;
    idn?: string;
    del:number|undefined;

    date_created: string
    date_modified: string
    modified_by: string;
    _err: any;
}

export interface IOpFinder {
    _id: any
    text: string
}

export interface IOpColor {

    numer: number
    etap: string
    etap_graflow: any;
    technologia: string
    technologia_graflow: string
    kolor:string;
    nazwa: string
    wspolnota: string
    angle:number
    lpi:number
    pokrycie_procent: number
    pokrycie_cm: number
    miejscowy:number
    used:boolean
    _id:any // id colors[] w mongo cloudflow
    rgb:number[] 
    cmyk:number[] 

    file_path_128:string
    proofscope_url:string
    separacja:string
    wydatek_sita_puchn?:number
    wydatek?:number
    drops?:number;
    //kkt: never[];
}

export interface IOpSurowiecHandlowy {
    surowiec_id: number | undefined
    surowiec_idm: string
    il_rek: number
    szerokosc: number
}

export interface IOpKomponent {
    
    _id:any
    text: string
    komponent_id: string
    komponent_text:string
    komponent_typ: string
    komponent_nazwa: string
    komponent_exact: number
    komponent_exact_metry: number
    komponent_kolor: string
    komponent_polysk: string
    komponent_podklad: string
    komponent_grubosc_podkladu: number
    komponent_cena: number
    komponent_jm: string
    komponent_wydatek: number
    komponent_lead_time: number
    surowiec_handlowy: IOpSurowiecHandlowy | undefined

    zbiorczy: number

}

export interface IOpNewfoilParams {
    
    newfoil_x:number
	newfoil_y:number
	newfoil_z:number
	newfoil_u:number
	newfoil_koszt_płytki:number
	newfoil_koszt_matrycypatrycy:number
}


export interface IOpLbl {
    
    _id:any;
    parent_id:any;
    type:string
    version: number,
    date_created: string
    date_modified: string
    modified_by: string;
    _err: any
    del:number|undefined;

    projekt_idn:string

    status:OpLblStatusEnum
    status_msg:string;

    x:number;
    y:number;
    
    kto_projektowal:string
    kto_preflightowal:string
    kto_przygotowal_do_druku:string
    handlowiec:string;

    klient:IOpFinder;
    klient_index_id:string

    original_file_name: string
    file_path_64: string;
    file_path_128: string;
    file_path_512: string;
    file_path: string;
    file_url: string
    additional_files: any[];
    
    colors: IOpColor[]

    label_idn:string

    kalkulacja_finder: IOpFinder
    indeks_finder: IOpFinder
    nr_indeksu_erp: string;
    surowiec_podst_finder: IOpFinder
    wykrojnik_finder: IOpFinder
    jm_finder: IOpFinder

    email_do_akceptacji:string;
    strona:string

    idx_id:string|undefined;

    groups: any //IGroup[];
    msg: string | undefined;

    termin_wysylki: Date|undefined;
    wysylac_do_akceptacji: boolean|undefined;
    praca_pilna: boolean|undefined;

    handlowiec_obj: IOpFinder
    klient_obj: IOpFinder

    oferta_tree_id: string|undefined;
    tree_id: string|undefined;
    preflight_date: string;
    
    flekso:number|undefined;
    cyfra:number|undefined
   
}


export interface IOpTree  {
    _id:any;
    idn:string;
    type:string;
    fnd:string;
    del:number;
    date_created: string;
    date_modified:string;
    version: number;

    parent_id:string|undefined;
    parent_type:string|undefined;
    
    grupa_maszyn_ist:string|undefined; 
    grupa_maszyn_arr: string[];


    lbl:ILbl  | undefined;

    x:number
    y:number

}


export interface IOpEtap {

    _id:any
	etap_typ:string,

	rodzaj_farby:string;
	rodzaj_lakieru:string;

    grupa_maszyn:string // grupa maszyn, którą życzył sobie DH
	
}




export interface IOpEtapValidation {
    etap_id:any
    grupa_maszyn_valid:string  // grupa maszyn, na którą pozwolił algorytm
    grupy_maszyn_valid: string[] // 
    odpad: number
    odpad_zmiana:number
    zeby:number
    predkosc:number; // max prędkość dla etapu
}

export interface IOpEtapyValidations  {
    [key: string]: IOpEtapValidation;
}
/*
export interface IOpParent {
    
    prj_id:any
    lbl_id:any
    tree_id:any

    handlowiec_id: any
    handlowiec_text: string | undefined
    klient_id: any
    klient_text:string | undefined
    klient_kontakt_id: any
    klient_kontakt_text:string | undefined

    x: number | undefined
    y: number | undefined

    file_path_128_lbl:string|undefined
    file_url_lbl:string|undefined

}
*/

export interface IOpKKTSearch { 
    etap_graflow: string, 
    technologia_graflow: string, 
    kolor_graflow: string, 
    rodzaj_farby: string, 
    rodzaj_lakieru: string, 
    komponent_pierwsza_warstwa: string
}


export interface IOpKKT {
    etap_graflow: string
    technologia_graflow: string
    kolor_graflow: string
    manualnie: string
    niepotrzebny: string
    komponent_typ: string
    komponent_technologia: string
    komponent_suszenie: string
    komponent_kolor: string
    komponent_pierwsza_warstwa: string
    komponent_połysk: string
    komponent_spec: string
    komponent_klasa: string
    komponent_id: string
    komponent_nazwa: string
}


export interface IOpParent {

    prj_id:any | undefined
    prj_del:number | undefined

    lbl_id:any | undefined
    lbl_del:number | undefined

    tree_id:any| undefined
    tree_del:number| undefined
/*
    prj_idn: string
    prj_handlowiec:IFinder
    prj_klient:IFinder
    prj_del:number

    tree_grupa_maszyn_arr: string[]
    tree_del:number 
    tree_date_created: string
    tree_idn: string
    tree_nr:number
    tree_iml: number

    wykrojnik_x: number
    wykrojnik_y: number
    wykrojnik_ksztalt: string
    wykrojnik_nr: string
    wykrojnik_manualny: number
    wykrojnik_szerokosc: number


    lbl_del: number| undefined
    lbl_nazwa: string
    lbl_preflight_date: string
    lbl_status: string
    lbl_modified_by: string 
    lbl_x: number
    lbl_y: number
    lbl_handlowiec: string
    lbl_klient: string
    lbl_file_path: string
    lbl_original_file_name: string

    lbl_idx_nazwa_etykiety: string
    lbl_idx_nr_indeksu_erp: string
    lbl_idx_nr_indeksu_wzor_erp: string
    lbl_idx_numer_indeksu_u_klienta: string


    tree_etap_technologia_technologia_typ :string
    tree_etap_technologia_komponent_id :string
    tree_etap_technologia_komponent_typ :string
    tree_etap_technologia_komponent_nazwa :string
    tree_etap_etap_typ :string
    */
}

export interface IOpOperacja {
    
    _id: any
    version: number
    del:number;
    type:string
    touch: OpTouchEnum 
    dummy:number

    poso:number | undefined // pos in array operacje[]
    ido:number  | undefined // operacja_id in array operacje[]
    ide:number  | undefined // etap_id in operacje[]

    status: IOpStatus 
    parent: IOpParent | undefined
    etap: IOpEtap | undefined
    color: IOpColor | undefined
    kkt: IOpKKT | undefined
    komponent: IOpKomponent | undefined
    komponent_szerokosc: number | undefined
    

    //etap_typ: string 
    //technologia: string 
    zmiana:number 
	krotnosc:number 
    procent_kosztow:number    
    wydatek_sita_puchn:number|undefined

    newfoil_params: IOpNewfoilParams | undefined
    dbg?: any;

}

export interface IOpModifier {
    op: any
    touch: OpTouchEnum 
    prop: string | undefined
    prop_old_value: any | undefined
    prop_new_value: any | undefined
    user: string | undefined
    filter: any | undefined
    status: OpTouchEnum 
}